// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {Op} from './op.js'

export class OpsBundle {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): OpsBundle {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  static getRootAsOpsBundle(bb: flatbuffers.ByteBuffer, obj?: OpsBundle): OpsBundle {
    return (obj || new OpsBundle()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  static getSizePrefixedRootAsOpsBundle(bb: flatbuffers.ByteBuffer, obj?: OpsBundle): OpsBundle {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
    return (obj || new OpsBundle()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  ops(index: number, obj?: Op): Op | null {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset
      ? (obj || new Op()).__init(this.bb!.__indirect(this.bb!.__vector(this.bb_pos + offset) + index * 4), this.bb!)
      : null
  }

  opsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0
  }

  schemaVersion(): number {
    const offset = this.bb!.__offset(this.bb_pos, 6)
    return offset ? this.bb!.readUint16(this.bb_pos + offset) : 0
  }

  static startOpsBundle(builder: flatbuffers.Builder) {
    builder.startObject(2)
  }

  static addOps(builder: flatbuffers.Builder, opsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, opsOffset, 0)
  }

  static createOpsVector(builder: flatbuffers.Builder, data: flatbuffers.Offset[]): flatbuffers.Offset {
    builder.startVector(4, data.length, 4)
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addOffset(data[i]!)
    }
    return builder.endVector()
  }

  static startOpsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(4, numElems, 4)
  }

  static addSchemaVersion(builder: flatbuffers.Builder, schemaVersion: number) {
    builder.addFieldInt16(1, schemaVersion, 0)
  }

  static endOpsBundle(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject()
    builder.requiredField(offset, 4) // ops
    return offset
  }

  static createOpsBundle(
    builder: flatbuffers.Builder,
    opsOffset: flatbuffers.Offset,
    schemaVersion: number
  ): flatbuffers.Offset {
    OpsBundle.startOpsBundle(builder)
    OpsBundle.addOps(builder, opsOffset)
    OpsBundle.addSchemaVersion(builder, schemaVersion)
    return OpsBundle.endOpsBundle(builder)
  }
}
